import Swiper, {Pagination, Navigation} from "swiper";

export default class PromotionsSlider {
  constructor() {
    if (!document.querySelector('.promotions-slider__swiper')) return false

    this.slider = new Swiper('.promotions-slider__swiper', {
      modules: [Navigation, Pagination],

      pagination: {
        el: '.promotions-slider__swiper .swiper-pagination',
        clickable: true
      },

      navigation: {
        prevEl: '.promotions-slider__swiper .swiper-button-prev',
        nextEl: '.promotions-slider__swiper .swiper-button-next'
      }
    })
  }
}
